import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { FormControl, ListGroup } from 'react-bootstrap'
import { setActiveItem, filterProperties } from '../actions'
import { SET_ACTIVE_PROPERTY } from '../constants'
import { scrollCardIntoView } from '../components/utils'

const SearchBar = () => {

    const [searchValue, setSearchValue] = useState('')
    const [matches, setMatches] = useState([])
    const allLocations = useSelector(state => state.requestAllAddresses.addresses)
    const allCustomers = useSelector(state => state.getAllCustomers.customers)
    const activeRoute = useSelector(state => state.setActiveRoute.activeRoute)
    const dispatch = useDispatch()
    const location = useLocation()
    const navigate = useNavigate()
    const { routeId } = useParams()

    useEffect(() => {
        onSetMatches()
    }, [searchValue, allLocations, allCustomers]) 

    useEffect(() => {
        if (!location.pathname.startsWith('/routebuilder')) {
            setSearchValue('')
        } 
        if (matches !== '') {
            onSetMatches()
        }        
    }, [activeRoute])

    const selectCustomer = (customer) => {
        // Find out if the customer is on current route        
        let isOnRoute = activeRoute?.customers?.[customer.id]
              
        if (isOnRoute) {
            scrollCustomerIntoView(customer)
        } else if (location.pathname.startsWith('/displayRoute')) {
            navigate(`${routeId}/${customer.id}`)
        }
        dispatch(setActiveItem(customer, allLocations, SET_ACTIVE_PROPERTY))
        setMatches([])
    }

    const scrollCustomerIntoView = (customer) => {
        console.log(customer)
        let custIndex
        if(location.pathname === '/routebuilder') {
            custIndex = activeRoute.customers[customer.id]
        } else {
            custIndex = activeRoute.customers[customer.id]
        }     
        scrollCardIntoView(custIndex)           
    }

    const listStyle = {
        position: "absolute", 
        overflow: "scroll",
        zIndex: "99",
        visibility: ((matches.length > 0) && !(location.pathname.startsWith('/routebuilder'))) ? "visible" : "hidden"
    }

    const itemStyle = {
        whiteSpace: "nowrap",
    }

    const onSetMatches = () => {
        if (searchValue.length > 0 ) {
            const searchLower = searchValue.toLowerCase()

            // 1. Direct matches on service locations (name, address)
            const directMatches = allLocations.filter(location =>
                location.cust_name?.toLowerCase().includes(searchLower) ||
                location.service_address?.toLowerCase().includes(searchLower)
            )

            // 2. Find customers matching phone/email - use Set for O(1) lookups
            const matchingCustomerIdSet = new Set(
                allCustomers
                    .filter(customer =>
                        customer.cust_phone?.toLowerCase().includes(searchLower) ||
                        customer.cust_email?.toLowerCase().includes(searchLower) ||
                        customer.cust_email2?.toLowerCase().includes(searchLower)
                    )
                    .map(customer => customer.id)
            )

            // 3. Find service locations belonging to those customers - O(1) Set lookup
            const customerMatches = allLocations.filter(location =>
                matchingCustomerIdSet.has(location.cust_id)
            )

            // 4. Merge and deduplicate using Set for O(1) lookups
            const matchedIds = new Set(directMatches.map(m => m.id))
            const allMatches = [...directMatches]
            customerMatches.forEach(match => {
                if (!matchedIds.has(match.id)) {
                    matchedIds.add(match.id)
                    allMatches.push(match)
                }
            })

            setMatches(allMatches)
            let offRouteResults = []
            if (!activeRoute.name) {
                offRouteResults = [...allMatches]
            } else {
                allMatches.forEach(item => {
                    if (!activeRoute?.customers?.[item.id]) {
                        offRouteResults.push(item)
                    }
                })
            }
            if ((allMatches.length === 1)) {
                selectCustomer(allMatches[0])
            }
            dispatch(filterProperties(offRouteResults))
        } else {
            setMatches([])
            dispatch(filterProperties([]))
        }
    }

    const changeSearchValue = (event) => setSearchValue(event.target.value)

    return (
        <div style={{position: "relative"}}>
            <FormControl size="sm" type="search" onChange={changeSearchValue} placeholder="search" value={searchValue} />
            <ListGroup  style={listStyle} as="ul">
            {
                (matches.length > 0) ?
                matches.map(customer => (
                        <ListGroup.Item style={itemStyle} key={customer.id} action onClick={() => selectCustomer(customer)}>
                        {customer.cust_name} | {customer.service_address} | {allCustomers.find(c => c.id === customer.cust_id)?.cust_phone || ''}
                        </ListGroup.Item>
                    )
                ) : null
            }
            </ListGroup>
        </div>
    )
}

export default SearchBar
